export default {
  'da-DK': {
    countries: {
      AF: 'Afghanistan',
      AX: 'Åland',
      AL: 'Albanien',
      DZ: 'Algeriet',
      VI: 'Amerikanske Jomfruøer',
      AS: 'Amerikansk Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarktis',
      AG: 'Antigua og Barbuda',
      AR: 'Argentina',
      AM: 'Armenien',
      AW: 'Aruba',
      AU: 'Australien',
      AT: 'Østrig',
      AZ: 'Aserbajdsjan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Hviderusland',
      BE: 'Belgien',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BQ: 'Bonaire, Sint Eustatius og Saba',
      BA: 'Bosnien-Hercegovina',
      BW: 'Botswana',
      BV: 'Bouvetøen',
      BR: 'Brasilien',
      IO: 'Britisk territorium i Det Indiske Ocean',
      VG: 'Britiske Jomfruøer',
      BN: 'Brunei',
      BG: 'Bulgarien',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodja',
      CM: 'Cameroun',
      CA: 'Canada',
      CV: 'Kap Verde',
      KY: 'Caymanøerne',
      CF: 'Centralafrikanske Republik',
      TD: 'Tchad',
      CL: 'Chile',
      CN: 'Kina',
      CX: 'Juleøen',
      CC: 'Cocosøerne',
      CO: 'Colombia',
      KM: 'Comorerne',
      CG: 'Republikken Congo',
      CD: 'Den Demokratiske Republik Congo',
      XK: 'Kosovo',
      CK: 'Cookøerne',
      CR: 'Costa Rica',
      CI: 'Elfenbenskysten',
      HR: 'Kroatien',
      CU: 'Cuba',
      CW: 'Curaçao',
      CY: 'Cypern',
      CZ: 'Tjekkiet',
      DK: 'Danmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Den Dominikanske Republik',
      EC: 'Ecuador',
      EG: 'Egypten',
      SV: 'El Salvador',
      GQ: 'Ækvatorialguinea',
      ER: 'Eritrea',
      EE: 'Estland',
      ET: 'Etiopien',
      FK: 'Falklandsøerne',
      FO: 'Færøerne',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'Frankrig',
      GF: 'Fransk Guyana',
      PF: 'Fransk Polynesien',
      TF: 'Franske Sydterritorier',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgien',
      DE: 'Tyskland',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Grækenland',
      GL: 'Grønland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard- og McDonaldøerne',
      VA: 'Vatikanstaten',
      HN: 'Honduras',
      HK: 'Hongkong',
      HU: 'Ungarn',
      IS: 'Island',
      IN: 'Indien',
      ID: 'Indonesien',
      IR: 'Iran',
      IQ: 'Irak',
      IE: 'Irland',
      IM: 'Isle of Man',
      IL: 'Israel',
      IT: 'Italien',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kasakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KP: 'Nordkorea',
      KR: 'Sydkorea',
      KW: 'Kuwait',
      KG: 'Kirgisistan',
      LA: 'Laos',
      LV: 'Letland',
      LB: 'Libanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyen',
      LI: 'Liechtenstein',
      LT: 'Litauen',
      LU: 'Luxembourg',
      MO: 'Macao',
      MK: 'Nordmakedonien',
      MG: 'Madagaskar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldiverne',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshalløerne',
      MQ: 'Martinique',
      MR: 'Mauretanien',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Mikronesien',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongoliet',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Marokko',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Holland',
      NC: 'Ny Kaledonien',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolkøen',
      MP: 'Nordmarianerne',
      NO: 'Norge',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palæstina',
      PA: 'Panama',
      PG: 'Papua Ny Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Filippinerne',
      PN: 'Pitcairnøerne',
      PL: 'Polen',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Réunion',
      RO: 'Rumænien',
      RU: 'Rusland',
      RW: 'Rwanda',
      BL: 'Saint-Barthélemy',
      SH: 'Saint Helena, Ascension og Tristan da Cunha',
      KN: 'Saint Kitts og Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint-Martin (FR)',
      PM: 'Saint Pierre og Miquelon',
      VC: 'Saint Vincent og Grenadinerne',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'São Tomé og Príncipe',
      SA: 'Saudi-Arabien',
      SN: 'Senegal',
      RS: 'Serbien',
      SC: 'Seychellerne',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SX: 'Sint Maarten (NL)',
      SK: 'Slovakiet',
      SI: 'Slovenien',
      SB: 'Salomonøerne',
      SO: 'Somalia',
      ZA: 'Sydafrika',
      GS: 'Sydgeorgien og Sydsandwichøerne',
      SS: 'Sydsudan',
      ES: 'Spanien',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Surinam',
      SJ: 'Svalbard og Jan Mayen',
      SZ: 'Eswatini',
      SE: 'Sverige',
      CH: 'Schweiz',
      SY: 'Syrien',
      TW: 'Taiwan',
      TJ: 'Tadsjikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Østtimor',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad og Tobago',
      TN: 'Tunesien',
      TR: 'Tyrkiet',
      TM: 'Turkmenistan',
      TC: 'Turks- og Caicosøerne',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'De Forenede Arabiske Emirater',
      GB: 'Storbritannien',
      US: 'USA',
      UM: 'USA’s ydre småøer',
      UY: 'Uruguay',
      UZ: 'Usbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Vietnam',
      WF: 'Wallis og Futuna',
      EH: 'Vestsahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    },
  },
}
